import React, { Component, useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import Sidebar from "containers/sidebar";
import CalendarComponent from "containers/scheduler/calendar";
import TimeSlotManagementModal from "containers/scheduler/timeslot-management-modal";
import { find, propEq, isEmpty } from "ramda";
import ProjectFilter from "containers/scheduler/project-filter";
import ImportModeratorAvailabilityModal from "containers/scheduler/import-moderator-availability-modal";
import UnlinkModeratorAvailabilityModal from "containers/scheduler/unlink-moderator-availability";
import {
  localizedDateFormatter,
  getUserTimeZone,
  localizedTranslate,
  parseTimeZone,
} from "assets/localization";
import {
  fetchModeratorAvailability,
  postModeratorAvailability,
  putModeratorAvailability,
  fetchAvailabilityAndTimeslotsForProject,
  fetchImportAvailabilityStatus,
  startFetchImporetdModeratorAvailability,
  unlinkModeratorCalendar,
  updateGoogleSpreadSheet,
} from "store/scheduler/schedulerActions";
import { isQSAdmin, isModerator, isPMOrAdmin } from "shared/helpers/user";
import "less/scheduler/index.less";
import Switch from "components/controls/switch-component";
import Select from "react-select";
import { Position, Tooltip, Overlay, Spinner } from "@blueprintjs/core";
import Button from "components/controls/button";
import EditInterviewOrModeratorBufferModal from "containers/dashboard/edit-interview-or-moderator-buffer-modal";
import { fetchUser } from "store/user/userActions";
import { updateModeratorDetails } from "store/moderator/moderatorActions";
import { timezone, timezoneAbbreviationLabel } from "shared/helpers/user";
import TimezoneSelect from "components/timezone-select";
import CombinedAvailabilityWarningModal from "containers/scheduler/combined-availability-warning-modal";

const Topbar = (props) => (
  <div className="topbar-container">
    <div className="topbar">
      <div className="moderator-schedule-header">
        <h4>
          {props.isPMOrAdmin ? "All Moderator Calendar" : "Schedule"}{" "}
          <span>
            (All times are in {timezoneAbbreviationLabel(props.userTimeZone)})
          </span>
        </h4>
        {props.isPMOrAdmin ? (
          <p
            className="all-moderator-message"
            dangerouslySetInnerHTML={{
              __html: props.t("scheduler.header.pm", {
                markup: {
                  tagStart: `<a href='${window.location.origin}/moderatorManagement/schedule'> moderator management. </a>`,
                },
              }),
            }}
          />
        ) : (
          <span> {props.t("schedule.header.moderator")} </span>
        )}
      </div>
      {props.isModerator && (
        <ProjectFilter
          collection={props.collection}
          filteredItems={props.filteredItems}
          collectionToFilter={props.collectionToFilter}
          icon="im-ss-inboxes"
          onSelectAll={() => {
            props.filterSchedule();
            props.fetchScheduleEvents();
          }}
          onClearAll={() => {
            props.collection.map((project) =>
              props.filterSchedule(project.value),
            );
            props.fetchScheduleEvents();
          }}
          onChange={(newOption) => {
            props.filterSchedule(newOption.value);
            props.fetchScheduleEvents();
          }}
        />
      )}
      {props.isPMOrAdmin && (
        <div className="pm-switch-filter">
          <Switch
            firstToggle={"Projects"}
            secondToggle={"Moderators"}
            selectedToggle={props.filterBy === "Projects" ? 0 : 1}
            onToggle={(val) => {
              val === 0
                ? props.toggleFilterBy({ filterBy: "Projects" })
                : props.toggleFilterBy({ filterBy: "Moderators" });
            }}
          />
          <ProjectFilter
            collection={props.collection}
            filteredItems={props.filteredItems}
            collectionToFilter={props.collectionToFilter}
            icon={props.filterBy === "Projects" ? "im-ss-inboxes" : "im-user2"}
            onSelectAll={() => {
              props.filterSchedule();
              props.fetchScheduleEvents();
            }}
            onClearAll={() => {
              props.collection.map((project) =>
                props.filterSchedule(project.value),
              );
              props.fetchScheduleEvents();
            }}
            onChange={(newOption) => {
              props.filterSchedule(newOption.value);
              props.fetchScheduleEvents();
            }}
          />
        </div>
      )}
    </div>
  </div>
);

const IconRenderer = () => (
  <span className="place-holder">
    <i className="im-user2" />
  </span>
);

const ModeratorManagementTopbar = (props) => {
  const renderProjectValue = () => <IconRenderer />;
  const [moderatorValues, setModeratorValues] = useState([]);
  const [chosenModerator, setchosenModerator] = useState(
    props.singleModerator ? props.singleModerator.label : "Select a moderator",
  );
  const [chosenModeratorId, setchosenModeratorId] = useState(
    props.singleModerator ? props.singleModerator.id : -1,
  );
  const [showTooltip, setShowTooltip] = useState(
    chosenModerator === "Select a moderator",
  );
  const [importAvStatus, setImportAvStatus] = useState(
    props.importAvStatus ? props.importAvStatus : "",
  );
  const POOL_REQUEST_INTERVAL = 5000;

  useEffect(() => {
    if (importAvStatus == "Completed") {
      props.fetchScheduleEvents({
        moderatorId: chosenModeratorId,
        clientId: props.singleModerator.clientId,
      });
    }
  }, [importAvStatus]);

  useEffect(() => {
    props.fetchAllModerators();
  }, []);

  //Polling for import availability
  function useInterval(callback, delay) {
    const savedCallback = useRef();
    useEffect(() => {
      savedCallback.current = callback;
    }, [callback]);

    useEffect(() => {
      function tick() {
        savedCallback.current();
      }
      if (delay != null) {
        const id = setInterval(tick, delay);
        return () => {
          clearInterval(id);
        };
      }
    }, [callback, delay]);
  }

  useInterval(async () => {
    props.fetchImportAvailabilityStatus({ moderatorId: chosenModeratorId });
    setImportAvStatus(props.importAvStatus);
  }, POOL_REQUEST_INTERVAL);

  const clearTimeOut = () => {
    const timer = setTimeout(() => {
      //  In order to prevent selecting same moderator and posting an availability  in the same time the timeOut is added. After 0.5 s the action is dipatched.
      props.toggleAllowAddAv();
    }, 500);
    return () => clearTimeout(timer);
  };

  const selectModerator = (
    <div className="moderator-select">
      <Select
        searchable={false}
        value={chosenModerator}
        options={moderatorValues}
        valueRenderer={renderProjectValue}
        placeholder={
          <span
            className={`place-holder ${chosenModeratorId > 0 ? "selected" : ""}`}
          >
            <i className="im-user2" />
            {chosenModerator}
          </span>
        }
        onChange={(e) => {
          setchosenModerator(e.label);
          setchosenModeratorId(e.value);
          setShowTooltip(e.label === "Select a moderator");
          props.setSingleModerator({
            id: e.value,
            label: e.label,
            clientId: e.clientId,
            firstName: e.firstName,
          });
          props.fetchImportAvailabilityStatus({
            moderatorId: e.value,
            isForced: true,
          });
        }}
        onOpen={() => {
          setShowTooltip(false);
          props.toggleAllowAddAv();
        }}
        onClose={() => {
          setShowTooltip(chosenModerator === "Select a moderator");
          clearTimeOut();
        }}
      />
    </div>
  );

  const selectTimeZone = (
    <div className="calendar-timezone-select">
      <div className="timezone-select-title">
        TIME ZONE (THIS CALENDAR ONLY)
      </div>
      <TimezoneSelect
        searchable={false}
        value={props.moderatorManagementTimeZone}
        placeholder={timezone[props.moderatorManagementTimeZone]}
        onChange={(e) => {
          props.updateTimeZone(e.value);
        }}
        clearable={false}
        userTimeZone={props.userTimeZone}
        onOpen={props.toggleAllowAddAv}
        onClose={props.toggleAllowAddAv}
      ></TimezoneSelect>
    </div>
  );

  useEffect(() => {
    const fillItems = () => {
      let moderatorIds = new Set();
      let moderatorValues = [];
      if (props.allModerators.length > 0) {
         props.allModerators.forEach((mod) => {
          if (!moderatorIds.has(mod.id)) {
            moderatorValues.push({
              value: mod.id,
              label: `${mod.firstName} ${mod.lastName}`,
              clientId: mod.clientId || 1,
              firstName: mod.firstName,
              isGlobal: mod.isGlobal,
            });
            moderatorIds.add(mod.id);
          }
        });
      }
      moderatorValues.sort((a, b) => (b.isGlobal ? 1 : 0) - (a.isGlobal ? 1 : 0));
      setModeratorValues(moderatorValues);
    };
    fillItems();
  }, [props.allModerators]);

  return (
    <div className="topbar-container">
      <div className="topbar moderator-management-topbar">
        <div className="moderator-schedule-header">
          <div className="topbar-header">
            <h4>
              Moderator Management{" "}
              <span>
                (All times are in{" "}
                {timezoneAbbreviationLabel(props.userTimeZone)})
              </span>
            </h4>
            <span>{props.t("scheduler.header.moderator.management")}</span>
          </div>
          {selectTimeZone}
        </div>
        <div className="filter-toggles">
          <Overlay
            className={"add-overlay"}
            isOpen={chosenModerator === "Select a moderator"}
          >
            <Tooltip
              popoverClassName={"manage-moderators-tooltip"}
              content={
                showTooltip ? props.t("moderator.management.tooltip") : ""
              }
              position={Position.BOTTOM}
              className={"manage-moderators-tooltip-message"}
              isOpen={showTooltip}
              enforceFocus={false}
            >
              {selectModerator}
            </Tooltip>
          </Overlay>

          {chosenModerator !== "Select a moderator" && selectModerator}
        </div>
      </div>
    </div>
  );
};

class Scheduler extends Component {
  isPMOrAdmin = isPMOrAdmin();
  isModerator = isModerator();
  isQSAdmin = isQSAdmin();
  isModeratorManagement =
    window.location.href.indexOf("moderatorManagement") > -1;
  state = {
    linksArray: [
      {
        display: "Interviews",
        icon: "im-ic-interview",
        path: "/interviews",
      },
      {
        display: this.isPMOrAdmin ? "All Moderator Calendar" : "My Schedule",
        icon: this.isPMOrAdmin ? "im-calendar-all-moderator" : "im-calendar",
        path: "/moderator/schedule",
        className: this.isPMOrAdmin ? "all-moderator-schedule" : "",
      },
      {
        display: "Profile",
        icon: "im-ss-user",
        path: "/profile",
      },
    ],
  };

  componentDidMount() {
    if (isEmpty(this.props.projectList)) {
      let payload = { clientId: this.props.clientId };
      if (this.isModerator) {
        const moderatorId = this.props.user.userId;
        payload.moderatorId = moderatorId;
      }
      this.props.user.userId && this.props.fetchProjects(payload);
    }

    if (
      isEmpty(this.props.moderatorList) &&
      !this.props.noModerators &&
      !this.isModerator
    ) {
      this.props.fetchModerators({ clientId: this.props.clientId });
    }
    if (!this.props.forAdmin) this.props.clearProject();
    if (this.isPMOrAdmin) {
      let linksArr = this.state.linksArray.slice();
      linksArr.splice(0, 0, {
        display: "Projects",
        icon: "im-ss-inboxes",
        path: "/projects",
      });
      linksArr.splice(3, 0, {
        display: "Moderator Management",
        icon: "im-user2",
        path: "/moderatorManagement/schedule",
        className: "all-moderator-schedule",
      });
      this.isQSAdmin &&
        linksArr.splice(4, 0, {
          display: "User Management",
          path: "/userManagement",
          className: "user-management",
        });
      this.setState({ linksArray: linksArr });
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.user.userId) {
      if (prevProps.user.userId !== this.props.user.userId) {
        if (isEmpty(this.props.projectList)) {
          let payload = { clientId: this.props.clientId };
          const moderatorId = this.props.user.userId;
          payload.moderatorId = moderatorId;
          this.props.fetchProjects(payload);
        }
      }
    }
  }

  parseFilterableCollection = () => {
    const projectList = this.props.projectList[this.props.clientId]
      ? this.props.projectList[this.props.clientId]
      : [];
    if (this.isPMOrAdmin && this.props.filterBy === "Moderators") {
      return this.props.moderatorList.map((user) => ({
        value: user.id,
        label: `${user.firstName} ${user.lastName}`,
      }));
    }
    return projectList.map((proj) => {
      return { value: proj.id, label: proj.name };
    });
  };

  render() {
    return (
      <div id="moderator-app" className="top-level-content-wrap">
        {this.props.isLoading && (
          <div className="scheduler-loading-overlay">
            <Spinner intent="primary" />
          </div>
        )}
        <Sidebar links={this.state.linksArray} />
        <div
          className={`top-level-content ${this.props.forAdmin ? "admin-scheduler" : ""}`}
        >
          {this.isModeratorManagement ? (
            <ModeratorManagementTopbar
              userTimeZone={this.props.moderatorManagementTimeZone}
              filterSchedule={this.props.filterSchedule}
              fetchScheduleEvents={this.props.fetchModeratorAvailability}
              moderatorList={this.props.moderatorList}
              t={this.props.t}
              singleModerator={this.props.singleModerator}
              setSingleModerator={this.props.setSingleModerator}
              allModerators={this.props.allModerators}
              fetchImportAvailabilityStatus={
                this.props.fetchImportAvailabilityStatus
              }
              importAvStatus={this.props.importAvStatus}
              fetchAllModerators={this.props.fetchAllModerators}
              moderatorManagementTimeZone={
                this.props.moderatorManagementTimeZone
              }
              updateTimeZone={this.props.updateTimeZone}
              toggleAllowAddAv={this.props.toggleAllowAddAv}
            />
          ) : (
            <Topbar
              userTimeZone={this.props.userInfo.timeZone}
              filteredItems={
                this.isModerator
                  ? this.props.filteredItems
                  : this.props.filterBy === "Projects"
                    ? this.props.filteredProjects
                    : this.props.filteredModerators
              }
              collection={this.parseFilterableCollection()}
              filterSchedule={this.props.filterSchedule}
              fetchScheduleEvents={this.props.fetchModeratorAvailability}
              collectionToFilter={
                this.isModerator ? "Projects" : this.props.filterBy
              }
              forAdmin={this.props.forAdmin}
              isModerator={this.isModerator}
              isPMOrAdmin={this.isPMOrAdmin}
              toggleFilterBy={(payload) => {
                this.props.toggleFilterBy(payload);
                this.props.fetchModeratorAvailability();
              }}
              filterBy={this.props.filterBy}
              t={this.props.t}
            />
          )}
          <div
            className={`moderator-schedule ${this.isModeratorManagement || this.isModerator ? "is-moderator-management" : ""} ${this.props.allowAddAv === true ? "" : "disabled"}`}
          >
            <CalendarComponent
              selectSlot={this.props.postModeratorAvailability}
              getSlots={this.props.fetchModeratorAvailability}
              putSlot={this.props.putModeratorAvailability}
              availability={this.props.availability}
              timeSlots={this.props.timeSlots}
              toggleTimeSlotPopover={this.props.toggleTimeSlotPopover}
              match={this.props.match}
              moderatorColorsById={this.props.moderatorColorsById}
              forAdmin={this.props.forAdmin}
              formatDate={this.props.formatDate}
              userTimeZone={this.props.userTimeZone}
              toggleAvailabilityPopover={this.props.toggleAvailabilityPopover}
              showMessage={this.props.showMessage}
              hideMessage={this.props.hideMessage}
              isModeratorManagement={this.isModeratorManagement}
              selectedModerator={this.props.singleModerator}
              allowAddAv={this.props.allowAddAv}
              t={this.props.t}
              fetchUser={this.props.fetchUser}
              moderatorManagementTimeZone={
                this.props.moderatorManagementTimeZone
              }
              user={this.props.user}
              fetchImportAvailabilityStatus={
                this.props.fetchImportAvailabilityStatus
              }
            />
            {this.props.isForcedLoading ? (
              <Spinner intent="primary" />
            ) : (
              <div className="calendar-footer">
                {this.isModeratorManagement &&
                  !this.props.isCalendarExportedBefore && (
                    <div className="import-moderator-availability-container">
                      <Button
                        className={`import-moderator-availability-button ${this.props.importAvStatus === "In Progress" || this.props.unlinkIsLoading ? "disabled" : ""}`}
                        onClick={() =>
                          this.props.canNotRunImport === false
                            ? this.props.toggleImportModeratorAvailabilityModal()
                            : (this.props.showSnackbarMessageError(
                                this.props.t("import.error.message"),
                              ),
                              this.props.hideMessage())
                        }
                      >
                        <i className="im-ss-upload" />
                        <span>
                          {this.props.t("import.availability.button")}
                        </span>
                      </Button>
                      <div className="import-moderator-availability-message">
                        {this.props.t("import.availability.message")}
                      </div>
                    </div>
                  )}
                {this.isModeratorManagement &&
                  this.props.isCalendarExportedBefore && (
                    <div className="import-moderator-availability-container">
                      <div className="moderator-time-buffer-container">
                        <div className="title">
                          {" "}
                          {this.props.t("external.availability.link.label")}
                          {this.isModeratorManagement && (
                            <span className="moderator-buffer-button">
                              <Button
                                className={`moderator-buffer-button btn-primary ${this.props.importAvStatus === "In Progress" || this.props.unlinkIsLoading ? "disabled" : ""}`}
                                onClick={() =>
                                  this.props.canNotRunImport === false
                                    ? this.props.toggleImportModeratorAvailabilityModal(
                                        {
                                          externalCalendar:
                                            this.props.externalCalendar,
                                          externalCalendarKey:
                                            this.props.externalCalendarKey,
                                        },
                                      )
                                    : (this.props.showSnackbarMessageError(
                                        this.props.t("import.error.message"),
                                      ),
                                      this.props.hideMessage())
                                }
                              >
                                <i className="im-edit" />
                                <span> EDIT </span>
                              </Button>
                            </span>
                          )}
                          <div className="view-external-link-button">
                            <Button
                              className="view-external-link-btn btn-primary"
                              onClick={() => {
                                window.open(this.props.externalCalendar);
                              }}
                            >
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: this.props.t("import.external.link", {
                                    markup: {
                                      tagStart: ` ${this.props.singleModerator.firstName} `,
                                    },
                                  }),
                                }}
                              />
                              <span className="im-ss-redirect"></span>
                            </Button>
                          </div>
                          <div className="external-link-update-button">
                            <span
                              className={
                                this.props.importAvStatus === "In Progress" ||
                                this.props.importAvStatus === "Failed"
                                  ? "im-circle red"
                                  : "im-circle green"
                              }
                            >
                              {" "}
                            </span>
                            <span>
                              {" "}
                              {this.props.importAvStatus === "In Progress"
                                ? "Update In-Progress | "
                                : this.props.unlinkIsLoading
                                  ? "Unlink In-Progress | "
                                  : this.props.importAvStatus === "Failed"
                                    ? "Update Failed | "
                                    : ""}{" "}
                            </span>

                            <span>
                              {" "}
                              Last Updated:{" "}
                              {this.props.formatDate(
                                this.props.modifiedOn,
                                "MMMM Do, YYYY h:mm A",
                              )}{" "}
                              {timezoneAbbreviationLabel(
                                this.props.moderatorManagementTimeZone,
                              )}{" "}
                            </span>
                            <Button
                              className={`external-link-update-btn btn-primary ${this.props.importAvStatus === "In Progress" || this.props.unlinkIsLoading ? "disabled" : ""}`}
                              onClick={() =>
                                this.props.canNotRunImport === false
                                  ? this.props.startFetchImporetdModeratorAvailability(
                                      {
                                        moderatorId:
                                          this.props.singleModerator.id,
                                        clientId:
                                          this.props.singleModerator.clientId,
                                        imported: true,
                                        externalCalendar:
                                          this.props.calendarLink,
                                        key: this.props.externalCalendarKey,
                                        userId: this.props.user.userId,
                                        forceUpdate: true,
                                      },
                                    )
                                  : (this.props.showSnackbarMessageError(
                                      this.props.t("import.error.message"),
                                    ),
                                    this.props.hideMessage())
                              }
                            >
                              {" "}
                              Update Now
                            </Button>
                          </div>
                          {this.props.importAvStatus === "Failed" && (
                            <i className="update-failed-message">
                              {" "}
                              Try updating the link to refresh or update the
                              moderator's external document link.{" "}
                            </i>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                {(this.isModeratorManagement || this.isModerator) && (
                  <div className="moderator-time-buffer-container">
                    <div className="title">
                      {" "}
                      {this.isModeratorManagement
                        ? this.props.t("project.manager.buffer.title")
                        : this.isModerator
                          ? this.props.t("mod.buffer.title")
                          : ""}
                      {this.isModeratorManagement && (
                        <span className="moderator-buffer-button">
                          <Button
                            className="moderator-buffer-button btn-primary"
                            onClick={() =>
                              this.props.openEditInterviewOrModeratorBufferModal(
                                { flag: "moderatorBuffer" },
                              )
                            }
                          >
                            <i className="im-edit" />
                            <span> EDIT </span>
                          </Button>
                        </span>
                      )}
                    </div>
                    <div className="message">
                      {this.props.moderatorDetails.moderatorBuffer}{" "}
                      {this.props.t("mod.buffer.message")}
                      <Tooltip
                        popoverClassName={`moderator-buffer-message ${this.isModeratorManagement ? "moderator-management" : ""}`}
                        content={
                          this.isModeratorManagement
                            ? this.props.t("pm.tooltip.message")
                            : this.props.t("mod.buffer.tooltip.message")
                        }
                        position={Position.RIGHT}
                        className="moderator-buffer-tooltip"
                      >
                        <p className="im-help"></p>
                      </Tooltip>
                    </div>
                    {this.props.moderatorDetails &&
                      this.props.moderatorDetails.lastUpdatedOn !== null && (
                        <div className="updated-on">
                          {" "}
                          Last Updated:{" "}
                          {this.props.formatDate(
                            this.props.moderatorDetails.lastUpdatedOn,
                            "MMMM Do, YYYY h:mm A",
                          )}{" "}
                          {this.isModerator
                            ? timezoneAbbreviationLabel(this.props.userTimeZone)
                            : timezoneAbbreviationLabel(
                                this.props.moderatorManagementTimeZone,
                              )}
                        </div>
                      )}
                  </div>
                )}
              </div>
            )}
            {this.props.importModeratorAvOpen && (
              <ImportModeratorAvailabilityModal
                isOpen={this.props.importModeratorAvOpen}
                moderatorName={this.props.singleModerator.label}
                downloadGoogleSheetLoading={
                  this.props.downloadGoogleSheetLoading
                }
                isSubmitting={this.props.isLoadingAvailabilities}
                t={this.props.t}
                onClose={this.props.toggleImportModeratorAvailabilityModal}
                onSubmit={(calendarLink, calendarKey) => {
                  this.props.startFetchImporetdModeratorAvailability({
                    moderatorId: this.props.singleModerator.id,
                    clientId: this.props.singleModerator.clientId,
                    imported: true,
                    externalCalendar: calendarLink,
                    key: calendarKey,
                    userId: this.props.user.userId,
                  });
                }}
                externalCalendar={this.props.externalCalendar}
                externalCalendarKey={this.props.externalCalendarKey}
                showURLAlreadyUsedError={this.props.showURLAlreadyUsedError}
                otherModeratorName={this.props.moderatorName}
                importAvStatus={this.props.importAvStatus}
                canNotRunImport={this.props.canNotRunImport}
                setShowUniqueURLError={this.props.setShowUniqueURLError}
                unlinkModal={this.props.toggleUnlinkImportModeratorModal}
                updateGoogleSheet={this.props.updateGoogleSpreadSheet}
                unlinkImportModeratorOpen={this.props.unlinkImportModeratorOpen}
                toggleImportModeratorAvailabilityModal={
                  this.props.toggleImportModeratorAvailabilityModal
                }
              />
            )}
            {this.props.unlinkImportModeratorOpen && (
              <UnlinkModeratorAvailabilityModal
                isOpen={this.props.unlinkImportModeratorOpen}
                moderatorName={this.props.singleModerator.label}
                isSubmitting={this.props.unlinkIsLoading}
                t={this.props.t}
                onClose={this.props.toggleUnlinkImportModeratorModal}
                onSubmit={() => {
                  this.props.unlinkModeratorCalendar({
                    moderatorId: this.props.singleModerator.id,
                    clientId: this.props.singleModerator.clientId,
                  });
                  //this.props.fetchModeratorAvailability()
                }}
                externalCalendar={this.props.externalCalendar}
                externalCalendarKey={this.props.externalCalendarKey}
                showURLAlreadyUsedError={this.props.showURLAlreadyUsedError}
                otherModeratorName={this.props.moderatorName}
                importAvStatus={this.props.importAvStatus}
                canNotRunImport={this.props.canNotRunImport}
                setShowUniqueURLError={this.props.setShowUniqueURLError}
              />
            )}
            {this.props.timeSlotModalOpen && (
              <TimeSlotManagementModal
                isOpen={this.props.timeSlotModalOpen}
                timeSlot={
                  this.props.selectedSlot || this.props.selectedSlotData
                }
                forAdmin={true}
                formatDate={this.props.formatDate}
                chosenAction={this.props.timeslotModalChosenAction}
                invalidateReschedule={this.props.invalidateReschedule}
                hideBackButton={
                  this.isModeratorManagement &&
                  this.props.invalidateReschedule &&
                  this.props.selectedSlot &&
                  this.props.selectedSlot.isInvalidateEmailSent === false
                    ? true
                    : false
                }
                invalidateSelectedFromCompleted={
                  this.props.invalidateSelectedFromCompleted
                }
                onBack={() => {
                  this.props.toggleModal();
                }}
              />
            )}
            {this.props.warningModalOpen && (
              <CombinedAvailabilityWarningModal
                isOpen={this.props.warningModalOpen}
                onClose={this.props.toggleCombinedAbWarningModal}
                onSubmit={this.props.toggleModal}
                timeSlot={this.props.selectedSlot}
                toggleCombinedAbWarningModal={
                  this.props.toggleCombinedAbWarningModal
                }
                t={this.props.t}
              />
            )}
          </div>
        </div>
        {this.props.editInterviewOrModeratorBufferModal.isOpen && (
          <EditInterviewOrModeratorBufferModal
            isOpen={this.props.editInterviewOrModeratorBufferModal.isOpen}
            onClose={this.props.closeEditInterviewOrModeratorBufferModal}
            isSubmitting={this.props.moderatorBufferIsSubmitting}
            t={this.props.t}
            currentProject={this.props.currentProject}
            onSubmit={this.props.updateModeratorDetails}
            flag={this.props.flag}
            moderatorBuffer={this.props.moderatorDetails.moderatorBuffer}
            singleModerator={this.props.singleModerator}
          />
        )}
      </div>
    );
  }
}

const mapState = (state) => ({
  userInfo: state.user.userInfo,
  availability: state.scheduler.availability,
  timeSlots: state.scheduler.timeSlots,
  filterBy: state.scheduler.filterBy,
  timeSlotModalOpen: state.scheduler.timeSlotModalOpen,
  timeslotModalChosenAction: state.scheduler.timeslotModalChosenAction,
  invalidateReschedule: state.scheduler.invalidateReschedule,
  invalidateSelectedFromCompleted:
    state.scheduler.invalidateSelectedFromCompleted,
  selectedSlot: find(
    propEq("timeSlotId", state.scheduler.selectedSlotId),
    state.scheduler.timeSlots,
  ),
  selectedSlotData: state.scheduler.selectedSlotData,
  filteredItems: state.scheduler.filteredItemsById,
  filteredModerators: state.scheduler.filteredModerators,
  filteredProjects: state.scheduler.filteredProjects,
  isLoadingAvailabilities: state.scheduler.isLoadingAv,
  unlinkIsLoading: state.scheduler.unlinkIsLoading,
  projectUsers: state.currentProject.users,
  moderatorColorsById: state.scheduler.moderatorColorsById,
  importModeratorAvOpen: state.scheduler.importModeratorAvOpen,
  unlinkImportModeratorOpen: state.scheduler.unlinkImportModeratorOpen,
  formatDate:
    window.location.href.indexOf("moderatorManagement") > -1
      ? localizedDateFormatter("en", state.scheduler.selectedTimeZone)
      : localizedDateFormatter("en", getUserTimeZone(state)),
  userTimeZone: getUserTimeZone(state),
  projectList: state.projectList.byClientId,
  moderatorList: state.moderatorList.moderatorList,
  noModerators: state.moderatorList.noModerators,
  currentProject: state.currentProject,
  participantId: state.scheduler.intervieweeId,
  clientId: state.client.clientId,
  singleModerator: state.scheduler.singleModerator,
  t: localizedTranslate("en", state.translations.en_us),
  allowAddAv: state.scheduler.allowAddAv,
  allModerators: state.moderatorList.allModerators,
  editInterviewOrModeratorBufferModal:
    state.ui.editInterviewOrModeratorBufferModal,
  flag: state.ui.editInterviewOrModeratorBufferModal.flag,
  moderatorDetails: state.moderator.moderatorDetails,
  moderatorBufferIsSubmitting: state.moderator.moderatorBufferIsSubmitting,
  moderatorManagementTimeZone: state.scheduler.selectedTimeZone,
  user: state.user,
  importAvStatus: state.scheduler.importAvStatus,
  canNotRunImport: state.scheduler.canNotRunImport,
  isLoading: Boolean(state.editSession && state.editSession.isSubmitting),
  isCalendarExportedBefore: state.scheduler.isCalendarExportedBefore,
  isForcedLoading: state.scheduler.isForcedLoading,
  externalCalendar: state.scheduler.externalCalendar,
  externalCalendarKey: state.scheduler.externalCalendarKey,
  modifiedOn: state.scheduler.modifiedOn,
  showURLAlreadyUsedError: state.scheduler.showURLAlreadyUsedError,
  moderatorName: state.scheduler.moderatorName,
  warningModalOpen: state.scheduler.warningModalOpen,
  downloadGoogleSheetLoading: state.scheduler.downloadGoogleSheetLoading,
});

const mapDispatch = {
  fetchModeratorAvailability,
  postModeratorAvailability,
  putModeratorAvailability,
  fetchImportAvailabilityStatus,
  toggleTimeSlotPopover: (payload) => ({
    type: "TOGGLE_TIMESLOT_POPOVER",
    payload,
  }),
  fetchAvailabilityAndTimeslotsForProject,
  fetchProjects: (payload) => ({
    type: "FETCH_ALL_PROJECTS_REQUESTED",
    payload,
  }),
  fetchModerators: (payload) => ({
    type: "FETCH_ALL_MODERATORS_REQUESTED",
    payload,
  }),
  toggleFilterBy: (payload) => ({ type: "TOGGLE_FILTER", payload }),
  filterSchedule: (payload) => ({ type: "FILTER_SCHEDULE_REQUESTED", payload }),
  toggleAvailabilityPopover: (payload) => ({
    type: "TOGGLE_AVAILABILITY_POPOVER",
    payload,
  }),
  resetModeratorState: () => ({ type: "RESET_MODERATOR_STATE" }),
  showMessage: (payload) => ({
    type: "SHOW_MESSAGE",
    payload: {
      message: payload,
      className: "copy-screeners-snackbar copy-screeners-snackbar-link",
    },
  }),
  toggleImportModeratorAvailabilityModal: (payload) => ({
    type: "TOGGLE_IMPORT_MODERATOR_AVAILABILITY_MODAL",
    payload,
  }),
  toggleUnlinkImportModeratorModal: (payload) => ({
    type: "TOGGLE_UNLINK_MODERATOR_AVAILABILITY_MODAL",
    payload,
  }),
  hideMessage: (payload) => ({ type: "HIDE_MESSAGE", payload }),
  updateTimeZone: (payload) => ({ type: "SET_SCHEDULER_TIMEZONE", payload }),
  clearProject: () => ({ type: "CLEAR_PROJECT_INQUIRY" }),
  setSingleModerator: (payload) => ({ type: "SET_SINGLE_MODERATOR", payload }),
  fetchAllModerators: () => ({
    type: "FETCH_ALL_MODERATORS_WITHOUT_CLIENT_ID_REQUESTED",
  }),
  openEditInterviewOrModeratorBufferModal: (payload) => ({
    type: "OPEN_EDIT_INTERVIEW_OR_MODERATOR_BUFFER_MODAL",
    payload,
  }),
  closeEditInterviewOrModeratorBufferModal: () => ({
    type: "CLOSE_EDIT_INTERVIEW_OR_MODERATOR_BUFFER_MODAL",
  }),
  updateModeratorDetails,
  fetchUser,
  toggleAllowAddAv: () => ({ type: "TOGGLE_ALLOW_ADD_AV" }),
  startFetchImporetdModeratorAvailability,
  unlinkModeratorCalendar,
  updateGoogleSpreadSheet,
  setShowUniqueURLError: (payload) => ({
    type: "SET_CALENDAR_URL_ALREADY_USED_ERROR",
    payload,
  }),
  toggleCombinedAbWarningModal: (payload) => ({
    type: "TOGGLE_IMP_AVA_WARNING_MODAL",
    payload,
  }),
  toggleModal: (timeSlotId) => ({
    type: "TOGGLE_TIMESLOT_MODAL",
    payload: { timeSlotId, fetchAll: true },
  }),
  showSnackbarMessageError: (message) => ({
    type: "SHOW_MESSAGE",
    payload: {
      message: message,
      className: "copy-screeners-snackbar",
    },
  }),
};

export default connect(mapState, mapDispatch)(Scheduler);
